import React, { memo } from 'react';
import { Button } from 'antd';
import { SettingOutlined } from '@ant-design/icons';

interface PresentationToggleProps {
  showPresentation: boolean;
  onTogglePresentation: () => void;
}

export const PresentationToggle = memo(({ showPresentation, onTogglePresentation }: PresentationToggleProps) => {
  return (
    <Button
      type="text"
      icon={<SettingOutlined style={{ fontSize: '30px' }} />}
      onClick={onTogglePresentation}
      style={{
        position: 'absolute',
        top: '20px',
        right: showPresentation ? '30%' : '20px',
        zIndex: 1000,
        color: 'var(--color-primary-600)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'white',
        borderRadius: '4px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        transition: 'right 0.3s ease',
        width: '40px',
        height: '40px',
        padding: '8px'
      }}
    />
  );
});

PresentationToggle.displayName = 'PresentationToggle'; 